import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const ResourceItem = styled.div<{
  $hasOverlay: boolean
  $videoIcon: string
  $companyLogo: string
  $categoryIcon: string
}>`
  > a {
    text-decoration: none;
  }

  ${({ $hasOverlay, $videoIcon, $companyLogo, $categoryIcon }) =>
    $hasOverlay
      ? `
    .ResourceRow__Image-Container:before {
      content: '';
      background: rgb(0, 0, 0, ${$companyLogo || $categoryIcon || $videoIcon ? '.1' : '.05'});
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
    }`
      : ''}

  ${({ theme, $companyLogo, $categoryIcon, $videoIcon, $hasOverlay }) => {
    if ($companyLogo)
      return `
      .ResourceRow__Item-Logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 120px;
        width: 240px;

        ${theme.breakpoints.down('md')} {
          height: 95px;
          width: 190px;
        }

        ${theme.breakpoints.down('sm')} {
          height: 113px;
          width: 226px;
        }

        ${theme.breakpoints.down('xs')} {
          height: 103px;
          width: 206px;
        }
      }
    `

    let iconStyles = ''
    if ($categoryIcon || $videoIcon) {
      iconStyles += `
        position: absolute;
        left: 1px;
        bottom: 1px;
        height: 48px;
        width: 48px;
      `
    } else {
      return ``
    }

    if ($videoIcon) {
      iconStyles = `
        .ResourceRow__Item-Icon {
          ${$hasOverlay ? `opacity: .8;` : ''}
          ${iconStyles}
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      `
    } else if ($categoryIcon) {
      iconStyles = `
        .ResourceRow__Item-Icon {
          ${iconStyles}
        }
      `
    }

    return `
      ${iconStyles}
    `
  }}

  &:hover {
    box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.1);
  }

  width: 384px;
  background: ${({ theme }) => theme.webMktPalette.background.white};
  cursor: pointer;

  .CTA {
    margin: 16px 0 0;
    position: relative;
    z-index: 1;
  }

  &:not(:last-of-type) {
    margin-right: 24px;
  }

  &.Overlay:before {
    content: '';
    background: rgb(0, 0, 0, 0.1);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 304px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 360px;
    &:nth-of-type(1),
    &:nth-of-type(3) {
      margin-right: 16px;
    }
    &:nth-of-type(2) {
      margin: 0;
    }
    &:nth-of-type(3),
    &:nth-of-type(4) {
      margin-top: 16px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    max-width: 329px;
    width: 100%;

    &:nth-of-type(1) {
      margin: 0;
    }

    &:nth-of-type(2),
    &:nth-of-type(3),
    &:nth-of-type(4) {
      margin-top: 16px;
    }
  }
`

export const ResourceRowContainer = styled.div<{
  $topPadding: string
  $bottomPadding: string
  $pageType: string
  $isHomePage: boolean
  $theme: string
}>`
  ${({ theme, $topPadding, $bottomPadding, $theme, $pageType, $isHomePage }) => {
    let cardBoxAlignment = $pageType === 'aboutRPA' ? 'margin: 0 auto 0 0' : 'margin: 0 auto'
    let seeAllCtaColor =
      $theme === 'Grey'
        ? `color: ${theme.webMktPalette.text.actionLight}`
        : `color: ${theme.webMktPalette.text.primaryWhite}`
    return `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
      background-color: ${
        $theme === 'Grey'
          ? theme.webMktPalette.background.gray
          : theme.webMktPalette.background.dark
      };
      ${
        $isHomePage
          ? `
        ${theme.breakpoints.up('md')} {
          padding-top: 1px; // applied for negative margins
        }

        .ResourceRow__Outer-Container {
          margin-top: -81px;

          ${theme.breakpoints.down('md')} {
            margin-top: -69px;
          }

          ${theme.breakpoints.down('sm')} {
            margin-top: 0;
          }
        }
      `
          : ``
      }

      &.resourceRow--fullWidth {
        width: 100%;
        .ResourceRow__Outer-Container {
          ${cardBoxAlignment}
        }
      }

      &.resourceRow--fourCards {
        .ResourceRow__CTA-Container {
          .CTA {
            ${seeAllCtaColor}
          }
        }
      }

    `
  }}

  &.resourceRow--fullWidth {
    width: 100%;
    .ResourceRow__CTA-Container {
      text-align: left;
      ${({ theme }) => theme.breakpoints.down('xs')} {
        text-align: center;
      }
    }
    .ResourceRow__Card-Container {
      padding-bottom: 10px;
      justify-content: flex-start;
      .ResourceRow__Item {
        position: relative;

        .ResourceRow__Item-Video {
          .VideoPlayer__Image-File {
            height: 312px;
            object-fit: cover;
          }
          &.noMediaContainer {
            display: none;
          }
        }
        .TextContainer_Video_Overlay {
          position: absolute;
          inset: 0px;
          z-index: 1;
          opacity: 0;
          overflow: hidden;
          z-index: 9;
          > div,
          div > div {
            height: 100%;
          }
        }

        .ResourceRow__Image-Container {
          height: 312px;
          .ResourceRow__Pill-Container {
            display: none;
          }
          .ResourceRow__CtaBox {
            position: absolute;
            bottom: 0px;
            padding: 24px;
            .CTA {
              padding: 12px 12px;
              margin: 0;
              height: 40px;
              line-height: normal;
              .CTA__Arrow-Container {
                margin-left: 0;
                width: 16px;
                height: 16px;
                svg {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
        .ResourceRow__Text-Container {
          margin: 24px 0;
          .CTA {
            display: none;
          }
          .ResourceRow__Meta-Container {
            p {
              font-size: 16px;
              font-weight: 700;
              line-height: 20px;
            }
          }
          .ResourceRow__Item-Heading {
            font-size: 24px;
            line-height: 32px;
            margin: 32px 0;
          }
          .ResourceRow__Item-Body {
            margin: 0 0 24px 0;
            p {
              font-size: 16px;
              line-height: 24px;
            }
          }
        }

        &.tcVideo {
          .ResourceRow__Text-Container {
            .CTA {
              display: none;
            }
          }
        }

        .noMediaContainer {
          min-height: 224px;
          position: static;
          padding-bottom: 40px;
          .CTA {
            display: block;
            margin-bottom: 16px;
          }
          .noMedia {
            width: 40px;
            position: absolute;
            bottom: 24px;
            .CTA {
              padding: 12px 12px;
              margin: 0;
              height: 40px;
              line-height: normal;
              .CTA__Arrow-Container {
                margin-left: 0;
                width: 16px;
                height: 16px;
                svg {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }

  &.resourceRow--fourCards {
    width: 100%;
    .ResourceRow__Outer-Container {
      max-width: 1608px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        max-width: 736px;
      }
    }
    .ResourceRow__CTA-Container {
      text-align: left;
      ${({ theme }) => theme.breakpoints.down('xs')} {
        text-align: center;
      }
    }
    .ResourceRow__Card-Container {
      padding-bottom: 10px;
      .ResourceRow__Item {
        position: relative;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin-right: 0;
        }

        .ResourceRow__Item-Video {
          .VideoPlayer__Image-File {
            height: 216px;
            object-fit: cover;
          }
          &.noMediaContainer {
            display: none;
          }
        }
        .TextContainer_Video_Overlay {
          position: absolute;
          inset: 0px;
          z-index: 1;
          opacity: 0;
          overflow: hidden;
          z-index: 9;
          > div,
          div > div {
            height: 100%;
          }
        }

        .ResourceRow__Image-Container {
          height: 216px;
          .ResourceRow__Pill-Container {
            display: none;
          }
          .ResourceRow__CtaBox {
            position: absolute;
            bottom: 0px;
            padding: 24px;
            .CTA {
              padding: 12px 12px;
              margin: 0;
              height: 40px;
              line-height: normal;
              .CTA__Arrow-Container {
                margin-left: 0;
                width: 16px;
                height: 16px;
                svg {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
        .ResourceRow__Text-Container {
          margin: 24px 0;
          height: calc(100% - 264px);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .CTA {
            display: inline;
            color: ${({ theme }) => theme.webMktPalette.text.primaryBlack};
          }
          .ResourceRow__Meta-Container {
            p {
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
            }
          }
          .ResourceRow__Item-Heading {
            font-size: 20px;
            line-height: 24px;
            margin: 16px 0;
          }
          .ResourceRow__Item-Body {
            margin: 0 0 16px 0;
            p {
              font-size: 14px;
              line-height: 24px;
            }
          }
        }

        &.tcVideo {
          .ResourceRow__Text-Container {
            .CTA {
              display: none;
            }
          }
        }

        .noMediaContainer {
          min-height: 224px;
          position: static;
          height: calc(100% - 48px);
          .CTA {
            display: block;
            margin-bottom: 16px;
            span {
              display: none;
            }
            .CTA__Arrow-Container {
              margin-left: 0px;
            }
          }
          .noMedia {
            width: 40px;
            position: absolute;
            bottom: 24px;
            .CTA {
              padding: 12px 12px;
              margin: 0;
              height: 40px;
              line-height: normal;
              .CTA__Arrow-Container {
                margin-left: 0;
                width: 16px;
                height: 16px;
                svg {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }

  .ResourceRow__Card-Container {
    display: flex;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      flex-wrap: wrap;
      margin: 0 auto;
      justify-content: start;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 328px;
    }

    .ResourceRow__Item {
      position: relative;
      > a {
        height: 100%;
        display: block;
        position: absolute;
        width: 100%;
        z-index: 1;
      }

      .ResourceRow__Item-Video {
        .VideoPlayer__Image-File {
          height: 216px;
          object-fit: cover;
          ${({ theme }) => theme.breakpoints.down('md')} {
            height: 171px;
          }

          ${({ theme }) => theme.breakpoints.down('sm')} {
            height: 203px;
          }

          ${({ theme }) => theme.breakpoints.down('xs')} {
            height: 185px;
          }
        }
        &.noMediaContainer {
          display: none;
        }
      }
      .TextContainer_Video_Overlay {
        position: absolute;
        inset: 0px;
        z-index: 1;
        opacity: 0;
        overflow: hidden;
        z-index: 9;
        > div,
        div > div {
          height: 100%;
        }
      }

      &.tcVideo {
        .ResourceRow__Text-Container {
          .CTA {
            display: none;
          }
        }
      }
    }
  }

  .ResourceRow__Pill-Container {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
  }

  .ResourceRow__Pill {
    padding: 4px 8px;
    margin: 0;
    background: ${({ theme }) => theme.webMktPalette.button.secondaryWhite};
    color: ${({ theme }) => theme.webMktPalette.text.secondary};
    margin-right: 1px;
  }

  .ResourceRow__Image-Container {
    width: 100%;
    height: 216px;
    position: relative;

    ${({ theme }) => theme.breakpoints.down('md')} {
      height: 171px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      height: 203px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      height: 185px;
    }

    img {
      object-fit: cover;
      object-position: center;
    }

    .ResourceRow__BackgroundImg {
      width: 100%;
      height: 100%;
    }
  }

  .ResourceRow__Text-Container {
    padding: 0 24px;
    position: relative;
    margin: 32px 0;

    > *:first-child {
      margin-top: 0;
    }

    ul,
    ol {
      list-style: disc;
      padding-left: 24px;
      li {
        margin-top: 8px;
        p {
          margin: 0;
        }
      }
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      margin: 24px 0;
    }
  }

  .ResourceRow__Item-Date {
    color: rgba(0, 0, 0, 0.3);
    margin-left: auto;
  }

  .ResourceRow__Meta-Container {
    display: flex;
    align-items: center;
  }

  .ResourceRow__Item-Category {
    color: rgb(89, 90, 92);
    margin: 0;
  }

  .ResourceRow__Item-Heading,
  .ResourceRow__Item-Body {
    margin-top: 16px;
  }

  .ResourceRow__Item-Heading:hover {
    color: ${({ theme }) => theme.webMktPalette.text.actionLight};
  }

  .ResourceRow__Item-Body {
    p,
    li {
      color: ${({ theme }) => theme.webMktPalette.text.secondary};
    }
  }

  .ResourceRow__SeeAllItemsIntro {
    margin-top: 48px;
    text-align: center;
    margin: 48px auto 0;
    max-width: 701px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 548px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 329px;
    }
  }

  .ResourceRow__CTA-Container {
    text-align: center;
    margin-top: 24px;
  }
`
